"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _SimpleDate = require("UIComponents/core/SimpleDate");

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIDatePicker = _interopRequireDefault(require("UIComponents/input/UIDatePicker"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITimePicker = _interopRequireDefault(require("UIComponents/input/UITimePicker"));

var _DynoScheduling = require("lead-flows-ui/constants/DynoScheduling");

var DynoSchedulingForm =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DynoSchedulingForm, _PureComponent);
  (0, _createClass2.default)(DynoSchedulingForm, null, [{
    key: "propTypes",
    get: function get() {
      return {
        handleUpdate: _react.default.PropTypes.func,
        dateLabel: _react.default.PropTypes.object,
        timeLabel: _react.default.PropTypes.object,
        minValue: _react.default.PropTypes.number,
        minValueValidationMessage: _react.default.PropTypes.object,
        maxValue: _react.default.PropTypes.number,
        maxValueValidationMessage: _react.default.PropTypes.object,
        disabled: _react.default.PropTypes.bool,
        timeInterval: _react.default.PropTypes.number,
        error: _react.default.PropTypes.bool,
        value: _react.default.PropTypes.number
      };
    }
  }]);

  function DynoSchedulingForm(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DynoSchedulingForm);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DynoSchedulingForm).call(this));
    _this.state = (0, _extends2.default)({}, _this.deriveStateFromProps(props));
    _this.handleDateChange = _this.handleDateChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTimeChange = _this.handleTimeChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DynoSchedulingForm, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.deriveStateFromProps(nextProps));
    }
  }, {
    key: "deriveStateFromProps",
    value: function deriveStateFromProps(props) {
      var value = props.value,
          minValue = props.minValue,
          maxValue = props.maxValue;
      var now = this.getNow();
      var derivedValue = this.parseDateTime(value || null);
      var derivedMinValue = this.parseDateTime(minValue || now);
      var derivedMaxValue = this.parseDateTime(maxValue);
      var minTimeValue = this.getMinTimeValue(derivedValue, derivedMinValue);
      var maxTimeValue = this.getMaxTimeValue(derivedValue, derivedMaxValue);
      var timeInterval = props.timeInterval || _DynoScheduling.TIMEPICKER_INTERVAL;
      var derivedState = {
        dateValue: derivedValue.date,
        timeValue: derivedValue.time,
        minDateValue: derivedMinValue.date,
        minTimeValue: minTimeValue,
        maxDateValue: derivedMaxValue.date,
        maxTimeValue: maxTimeValue,
        timeInterval: timeInterval
      };
      return derivedState;
    }
  }, {
    key: "getNow",
    value: function getNow() {
      return _I18n.default.moment.portalTz().valueOf();
    }
  }, {
    key: "getMinTimeValue",
    value: function getMinTimeValue(derivedValue, derivedMinValue) {
      var dateDay = (0, _SimpleDate.toMoment)(derivedValue.date).unix();
      var minDateDay = (0, _SimpleDate.toMoment)(derivedMinValue.date).unix();
      var sameDay = dateDay === minDateDay;
      return sameDay ? derivedMinValue.time : 0;
    }
  }, {
    key: "getMaxTimeValue",
    value: function getMaxTimeValue(derivedValue, derivedMaxValue) {
      var dateDay = (0, _SimpleDate.toMoment)(derivedValue.date).unix();
      var minDateDay = (0, _SimpleDate.toMoment)(derivedMaxValue.date).unix();
      var sameDay = dateDay === minDateDay;
      return sameDay ? derivedMaxValue.time : 1440;
    }
  }, {
    key: "parseDateTime",
    value: function parseDateTime(dateTime) {
      var formatedDate = {
        date: undefined,
        time: undefined
      };

      if (dateTime) {
        var dateTimeMoment = _I18n.default.moment.utc(dateTime).portalTz();

        var midnight = _I18n.default.moment.utc(dateTime).portalTz().startOf('day');

        formatedDate = {
          date: (0, _SimpleDate.fromMoment)(dateTimeMoment),
          time: dateTimeMoment.diff(midnight, 'minutes')
        };
      }

      return formatedDate;
    }
  }, {
    key: "handleDateChange",
    value: function handleDateChange(_ref) {
      var value = _ref.target.value;
      this.handleupdateDateTimeChange({
        dateValue: value
      });
    }
  }, {
    key: "handleTimeChange",
    value: function handleTimeChange(_ref2) {
      var value = _ref2.target.value;
      this.handleupdateDateTimeChange({
        timeValue: value
      });
    }
  }, {
    key: "handleupdateDateTimeChange",
    value: function handleupdateDateTimeChange(newState) {
      var newDate = (0, _extends2.default)({}, this.state, newState);
      var fmtDateTime = (0, _SimpleDate.toMoment)(newDate.dateValue).add(newDate.timeValue, 'minutes').format(_DynoScheduling.DATETIME_FORMAT);

      var portalTz = _I18n.default.moment.portalTz().tz();

      var momentDateTime = _I18n.default.moment.tz(fmtDateTime, _DynoScheduling.DATETIME_FORMAT, portalTz);

      var dateTime = momentDateTime.valueOf();
      this.handleUpdate(dateTime);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(dateTime) {
      this.props.handleUpdate(dateTime);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dateLabel = _this$props.dateLabel,
          timeLabel = _this$props.timeLabel,
          minValueValidationMessage = _this$props.minValueValidationMessage,
          maxValueValidationMessage = _this$props.maxValueValidationMessage,
          disabled = _this$props.disabled,
          error = _this$props.error;
      var _this$state = this.state,
          dateValue = _this$state.dateValue,
          timeValue = _this$state.timeValue,
          minDateValue = _this$state.minDateValue,
          minTimeValue = _this$state.minTimeValue,
          maxDateValue = _this$state.maxDateValue,
          maxTimeValue = _this$state.maxTimeValue,
          timeInterval = _this$state.timeInterval;
      return _react.default.createElement(_UIFlex.default, {
        className: "dyno-scheduling-form",
        align: "end"
      }, _react.default.createElement(_UIBox.default, {
        className: "m-right-3"
      }, _react.default.createElement(_UIFormControl.default, {
        className: "dyno-scheduling-form__datepicker",
        label: dateLabel
      }, _react.default.createElement(_UIDatePicker.default, {
        disabled: disabled,
        error: error,
        maxValue: maxDateValue,
        maxValueValidationMessage: maxValueValidationMessage,
        minValue: minDateValue,
        minValueValidationMessage: minValueValidationMessage,
        value: dateValue,
        onChange: this.handleDateChange
      }))), _react.default.createElement(_UIBox.default, null, _react.default.createElement(_UIFormControl.default, {
        label: timeLabel
      }, _react.default.createElement(_UITimePicker.default, {
        disabled: disabled,
        interval: timeInterval,
        error: error,
        minValue: minTimeValue,
        maxValue: maxTimeValue,
        value: timeValue,
        onChange: this.handleTimeChange
      }))));
    }
  }]);
  return DynoSchedulingForm;
}(_react.PureComponent);

exports.default = DynoSchedulingForm;
module.exports = exports.default;